define.alias("shared/components/shared/ui/report/settings", "media/components/shared/ui/report/settings");